/***
 * Lightbox 1.0
 * 
 * Class Dependencies
 * 
 * LB Container: et-lb-content-[i]  
 * LB open button: et-lb-btn-[i]
 * 
 */
jQuery(function ($) {

    $(document).ready(function () {
        $('<span class="et-lb-close">M</span>').prependTo('body:not(.et-fb-root-ancestor) [class*="lb-content"]  > .et_pb_row:first-child');

        if ($('body:not(.et-fb-root-ancestor)').has('#et-boc').length) {
            $('body:not(.et-fb-root-ancestor) [class*="et-lb-content"]').wrapAll('<div id="et-boc" class="et-lb-wrapper"><div class="et-l"></div></div>');
            $('.et-lb-wrapper').appendTo('#et-main-area');
        } else {
            $('body:not(.et-fb-root-ancestor) [class*="et-lb-content"]').appendTo('#et-main-area');
        }

        $("[class*='et-lb-btn']").each(function (index, element) {
            var classes = $(element).attr('class').match(/et-lb-btn\-(\w*)/);
            if (classes !== null) {
                $(element).on('click', function (e) {
                    e.preventDefault();
                    // Lightbox öffnen und Scrollen verhindern
                    $('.et-lb-content-' + classes[1]).toggleClass('et-lb-open');
                    if ($('.et-lb-content-' + classes[1]).hasClass('et-lb-open')) {
                        $('body').css('overflow', 'hidden');
                    } else {
                        $('body').css('overflow', '');
                    }
                });
                
                // Lightbox schließen und Scrollen aktivieren
                $('.et-lb-close').click(function () {
                    $("[class*='et-lb-content']").removeClass('et-lb-open');
                    $('body').css('overflow', '');
                });
            }
        });

    });
});
  

